import { Component, OnInit } from '@angular/core';
import { WorkWithUs } from 'src/app/models/WorkWithUs';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-work-with-us',
  templateUrl: './work-with-us.component.html',
  styleUrls: ['./work-with-us.component.css']
})
export class WorkWithUsComponent implements OnInit {

  workWithUs = new Array<WorkWithUs>();
  constructor(private service: ApiService) { }

  async ngOnInit() {
    this.workWithUs = await this.service.getWorkWithUs();
    // this.customers.sort((a, b) => {
    //   return b.posizione - a.posizione;
    // })
  }

}
